import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

// UrlApi: "https://prd-ecommerce-und-api.primecasesuporte.com.br/api",
// UrlApi: "https://hlg-ecommerce-par-api.primecase.com.br/api",
let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage > 0 ?idHotsiteLocalStorage : 2,
  Loja: "Unida Ouro",
  UserStorage: "z1/ltjBd3UO1ZYOQUvKERA==",
  UserToken: "HBMHTS2cu0mVqgS5nVyX0A==",
  UrlApi: "https://prd-ecommerce-und-api.primecase.com.br/api",
  UrlLoja:"https://prd-ecommerce-uno-web.primecase.com.br/",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",
  OrgId: "9ozphlqx",
  ProviderMerchantId: "braspag_marlim_advanced",
  SecurityKey: "5AKI104KwDjj"
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#be8e2a",
      light: "#B799F2",
      //lighter: "#ece6f7",
      dark: darkenColor("#be8e2a", 10), // Escurece em 20%
    },
    secondary: {
      main: "#cd6939",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
